import React, { useEffect, useRef } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const Disease = () => {
  const applyAnimation = (animateRef) => {
    animateRef.current.style.opacity = "1";
    animateRef.current.style.animationDuration = "1.5s";
    animateRef.current.classList.add("animate__animated");
  };
  const animateRef1 = useRef();
  const animateRef2 = useRef();
  const animateRef3 = useRef();
  const animateRef4 = useRef();
  const animateRef5 = useRef();
  const animateRef6 = useRef();
  const animateRef7 = useRef();
  const animateRef8 = useRef();
  const animateRef9 = useRef();
  const animateRef10 = useRef();
  const animateRef11 = useRef();
  const animateRef12 = useRef();
  const animateRef13 = useRef();

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust this value based on when you want the animation to trigger
    };

    const handleIntersectionSlideInRight = (entries, observer, animateRef) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          applyAnimation(animateRef);
          animateRef.current.classList.add("animate__slideInRight");
          observer.unobserve(entry.target);
        }
      });
    };

    const handleIntersectionSlideInLeft = (entries, observer, animateRef) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          applyAnimation(animateRef);
          animateRef.current.classList.add("animate__slideInLeft");
          observer.unobserve(entry.target);
        }
      });
    };

    const observer1 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInRight(entries, observer, animateRef1),
      options
    );
    if (animateRef1.current) {
      animateRef1.current.style.opacity = "0";
      observer1.observe(animateRef1.current);
    }
    const observer2 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef2),
      options
    );
    if (animateRef2.current) {
      animateRef2.current.style.opacity = "0";
      observer2.observe(animateRef2.current);
    }
    const observer3 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInRight(entries, observer, animateRef3),
      options
    );
    if (animateRef3.current) {
      animateRef3.current.style.opacity = "0";
      observer3.observe(animateRef3.current);
    }
    const observer4 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef4),
      options
    );
    if (animateRef4.current) {
      animateRef4.current.style.opacity = "0";
      observer4.observe(animateRef4.current);
    }
    const observer5 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInRight(entries, observer, animateRef5),
      options
    );
    if (animateRef5.current) {
      animateRef5.current.style.opacity = "0";
      observer5.observe(animateRef5.current);
    }
    const observer6 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef6),
      options
    );
    if (animateRef6.current) {
      animateRef6.current.style.opacity = "0";
      observer6.observe(animateRef6.current);
    }
    const observer7 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef7),
      options
    );
    if (animateRef7.current) {
      animateRef7.current.style.opacity = "0";
      observer7.observe(animateRef7.current);
    }
    const observer8 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef8),
      options
    );
    if (animateRef8.current) {
      animateRef8.current.style.opacity = "0";
      observer8.observe(animateRef8.current);
    }
    const observer9 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef9),
      options
    );
    if (animateRef9.current) {
      animateRef9.current.style.opacity = "0";
      observer9.observe(animateRef9.current);
    }
    const observer10 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef10),
      options
    );
    if (animateRef10.current) {
      animateRef10.current.style.opacity = "0";
      observer10.observe(animateRef10.current);
    }
    const observer11 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef11),
      options
    );
    if (animateRef11.current) {
      animateRef11.current.style.opacity = "0";
      observer11.observe(animateRef11.current);
    }
    const observer12 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef12),
      options
    );
    if (animateRef12.current) {
      animateRef12.current.style.opacity = "0";
      observer12.observe(animateRef12.current);
    }
    const observer13 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef13),
      options
    );
    if (animateRef13.current) {
      animateRef13.current.style.opacity = "0";
      observer13.observe(animateRef13.current);
    }

    return () => {
      observer1.disconnect();
      observer2.disconnect();
      observer3.disconnect();
      observer4.disconnect();
      observer5.disconnect();
      observer6.disconnect();
      observer7.disconnect();

      observer8.disconnect();
      observer9.disconnect();
      observer10.disconnect();
      observer11.disconnect();
      observer12.disconnect();
      observer13.disconnect();
    };
  }, []);

  return (
    <div className="wrap main_wrap">
      <Header />
      <div className="di_wrap">
        <div className="page_banner_box">
          <div
            className="page_banner animate__animated animate__fadeIn"
            style={{ animationDuration: "2s" }}
          ></div>
          <div className="banner_text_box">
            <div className="banner_title">성조숙증</div>
          </div>
        </div>
        <div className="di_top_box animate__animated animate__slideInLeft">
          <div className="di_contents_box">
            <div className="di_title">*성조숙증 검사 내용 및 비용</div>
            <div className="di_text">
              # 아동들의 검사 불안과 걱정을 최소화하기 위해 본원은 최선의 노력을
              다하고 있습니다.
            </div>
            <div className="di_text">
              1. 성성숙도초음파 검사 15만원 유방 및 자궁의 성장 발달 단계 확인
              검사 입니다.
            </div>
            <div className="di_text">2. 성선호르몬 자극검사 (약1시간 소요)</div>
            <div className="di_text">
              성호르몬의 정확한 분비상태 확인을 위한 혈액검사이며 혈관도관삽입후
              수회 채혈하는 성조숙증 확진 검사로 필요한 경우
              진행하고있습니다.(성조숙증이 의심되어도 모든 경우 한시간
              혈액검사를 하지 않습니다.) 만 9세생일 이전에는 보험으로 검사
              가능합니다.
            </div>
            <div className="di_text">
              3. 성호르몬억제 주사 성조숙증이 확진된후 만 9세 생일 이전에 주사
              시작시 지속적으로 보험치료받을 수 있습니다.
            </div>
          </div>
        </div>
        <div className="di_middle_box">
          <div className="di_img_box">
            <div className="di_img"></div>
          </div>
        </div>
        <div className="di_chat_box">
          <div className="chat_back">
            <div className="chat_row right">
              <div className="chat_q_box animate__animated" ref={animateRef1}>
                <div className="chat_icon">Q.</div>
                <div className="chat_text">
                  검사 시 채혈에 따른 통증이나
                  <br />
                  공포심 유발이 걱정돼요.
                </div>
              </div>
            </div>
            <div className="chat_row">
              <div
                className="chat_q_box a_box animate__animated"
                ref={animateRef2}
              >
                <div className="chat_icon">A.</div>
                <div className="chat_text">걱정하지 않으셔도 됩니다.</div>
              </div>
            </div>
            <div className="chat_row">
              <div
                className="chat_img_box top animate__animated"
                ref={animateRef7}
              >
                <div className="chat_inner_box">
                  <div className="chat_img"></div>
                  <div className="chat_text_box">
                    <div className="chat_text bold">
                      본원만의 성조숙증검사 장점 1 :
                    </div>
                    <div className="chat_text">
                      사춘기 , 성조숙증검사를 통증없이 안전하고 정밀한 골연령 및
                      초음파로 우선 진행합니다.
                    </div>
                    <div className="chat_text">
                      ○ 본원 검사는 약 2시간 소요되며 여러 번 채혈하는 공포와
                      고통을 유발하는 성조숙증검사를 무조건 시행하지 않습니다.
                    </div>
                    <div className="chat_text">
                      ○ 초음파 검사로 정확하게 사춘기 몽우리가 발현이 되었는지
                      여부를 알 수 있습니다.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="chat_row right">
              <div className="chat_q_box animate__animated" ref={animateRef5}>
                <div className="chat_icon">Q.</div>
                <div className="chat_text">
                  가슴이 나온듯하면 무조건
                  <br /> 성조숙증 검사를 해야하나요?
                </div>
              </div>
            </div>
            <div className="chat_row">
              <div
                className="chat_q_box a_box animate__animated"
                ref={animateRef6}
              >
                <div className="chat_icon">A.</div>
                <div className="chat_text">아닙니다.</div>
              </div>
            </div>
            <div className="chat_row">
              <div
                className="chat_img_box bottom animate__animated"
                ref={animateRef4}
              >
                <div className="chat_inner_box">
                  <div className="chat_text_box">
                    <div className="chat_text bold">
                      본원만의 성조숙증검사 장점 2 :
                    </div>
                    <div className="chat_text">
                      골연령과 초음파 검사로 유방 및 자궁 발달을 우선으로 하여
                      사춘기 발달을 확인하고 성조숙증검사 진행의 여부를 확인 후
                      꼭 필요한 경우에만 진행중입니다. (불필요한검사X. 과잉진료
                      X)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page_banner_box bottom">
          <div className="page_banner"></div>
          <div className="banner_text_box">
            <div className="banner_title">
              사춘기, 성조숙증검사 통증없이 <br /> 안전하고 정밀한 골연령 및
              초음파로 우선 진행합니다.
            </div>
          </div>
        </div>
        <div className="di_bottom_box">
          <div className="bottom_container">
            <div className="bottom_title animate__animated" ref={animateRef8}>
              가슴이 나온듯하면 무조건 성조숙증 검사 해야하나요?
            </div>
            <div className="bottom_contents">
              <div className="bottom_text_row">
                <div
                  className="bottom_text animate__animated"
                  ref={animateRef9}
                >
                  ✓ 2시간소요되며 여러 번 채혈하는 공포와 고통을유발하는
                  성조숙증검사를 무조건 시행하지 않습니다.
                </div>
              </div>
              <div className="bottom_text_row">
                <div
                  className="bottom_text animate__animated"
                  ref={animateRef10}
                >
                  ✓ 골연령과 초음파 검사로 유방및자궁 발달을 우선으로 하여
                  사춘기 발달을 확인하고 성조숙증검사진행의 여부를 확인 후 꼭
                  필요한 경우에만진행중입니다. 불필요한검사X. 과잉진료X.
                </div>
              </div>
              <div className="bottom_text_row">
                <div
                  className="bottom_text animate__animated"
                  ref={animateRef11}
                >
                  ✓ 초음파 검사로 정확하게 사춘기 몽우리가 발현이 되었는지
                  여부를 알 수 있습니다.
                </div>
              </div>
              <div className="bottom_text_row">
                <div
                  className="bottom_text animate__animated"
                  ref={animateRef12}
                >
                  ✓ 소아초음파연구회 회장인 원장님께 편안하게 전문적으로
                  진료받으실 수있습니다.
                </div>
              </div>
              <div className="bottom_text_row">
                <div
                  className="bottom_text animate__animated"
                  ref={animateRef13}
                >
                  ✓ 검사후 성조숙증이 확실히 의심되면 2시간 성조숙증확진검사를
                  진행함.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Disease;
